import Vue from 'vue'
import moment from 'moment'

import api from '../api'
import {
    CREATE_NOTE,
    DELETE_NOTE,
    SET_ACTIVE_CONTACT,
    SET_STATS_CURRENT,
    SET_ACTIVE_KEY,
    SET_ACTIVE_NOTE,
    SET_APPRAISERS,
    SET_REALESTATES,
    SET_APPRAISALS,
    SET_WARNINGS,
    SET_CONSTRAINTS,
    SET_MARKETSTUDIES,
    SET_AD_COMPARABLES,
    SET_SUPERVISORS,
    SET_APPRAISALREPORTS,
    SET_APPRAISALINVOICES,
    SET_APPRAISALQUOTES,
    SET_CONTACTS,
    SET_BECPROPERTIES,
    SET_ENTITIES,
    SET_LANGUAGE,
    SET_NOTES,
    SET_RESULT_INDEX,
    SET_TAGS_DISPLAY,
    SET_THEME,
    SET_USER,
    SET_USER_ROLE,
    SET_VALUATION_PRICES,
    SET_BDE_APPRAISAL_FILES,
    SET_BDE_REALESTATE_FILES,
    SET_BDE_COMPARABLE_FILES,
    SET_BDE_RELATIONSHIPS_FILES,
    TOGGLE_IS_PUBLIC,
    UPDATE_BUDGET_REQUEST,
    UPDATE_NOTE
} from '../constants'

const state = {
    activeContact: null,
    activeKey: null,
    activeNote: null,
    bde_appraisal_files: {},
    bde_realestate_files: {},
    bde_comparable_files: {},
    bde_relationships_files: {},
    budget_request_data: null,
    appraisers: [],
    appraisalreports: [],
    realestates: [],
    appraisals: [],
    marketstudies: [],
    ad_comparables: [],
    supervisors: [],
    appraisalinvoices: [],
    appraisalquotes: [],
    contacts: [],
    entities: [],
    becproperties: [],
    notes: [],
    theme: 'light',
    tags_display: true,
    user_role: null,
    valuation_prices: {},
    warnings: [],
    constraints: [],
    stats_current: {}
}

const actions = {
    INIT_NOTES: ({state, commit, rootState}) => {
        //return api.initNotesForUserId(rootState.auth.user.uid)
    },

    UPDATE_USER_INITIAL_DATA: ({state, commit, rootState}, data) => {
        return api.updateUserInitialData(rootState.auth.user.uid, data)
    },

    SET_TAGS_DISPLAY: ({state, commit, rootState}, data) => {
        commit(SET_TAGS_DISPLAY, data)
    },
    SET_BDE_APPRAISAL_FILES: ({state, commit, rootState}, data) => {
        commit(SET_BDE_APPRAISAL_FILES, data)
    },
    SET_BDE_REALESTATE_FILES: ({state, commit, rootState}, data) => {
        commit(SET_BDE_REALESTATE_FILES, data)
    },
    SET_BDE_COMPARABLE_FILES: ({state, commit, rootState}, data) => {
        commit(SET_BDE_COMPARABLE_FILES, data)
    },
    SET_BDE_RELATIONSHIPS_FILES: ({state, commit, rootState}, data) => {
        commit(SET_BDE_RELATIONSHIPS_FILES, data)
    },
    FETCH_BECPROPERTIES: ({state, commit, rootState}) => {
        return api.get({path: 'becproperties'})
            .then((res) => {
                // console.log(res)
                commit(SET_BECPROPERTIES, res)
            })
    },
    FETCH_APPRAISERS: ({state, commit, rootState}) => {
        return api.get({path: 'appraisers'})
            .then((res) => {
                // console.log(res)
                commit(SET_APPRAISERS, res)
            })
    },
    FETCH_REALESTATES: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'realestates'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_REALESTATES, res)
                    resolve(res)
                })
        })
    },
    FETCH_APPRAISALS: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'realestate_appraisals'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_APPRAISALS, res)
                    resolve(res)
                })
        })
    },
    FETCH_WARNINGS: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'appraisal_warnings'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_WARNINGS, res)
                    resolve(res)
                })
        })
    },
    FETCH_CONSTRAINTS: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'appraisal_constraints'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_CONSTRAINTS, res)
                    resolve(res)
                })
        })
    },
    FETCH_MARKETSTUDIES: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'realestate_marketstudies'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_MARKETSTUDIES, res)
                    resolve(res)
                })
        })
    },
    FETCH_AD_COMPARABLES: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'marketstudy_ad_comparables'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_AD_COMPARABLES, res)
                    resolve(res)
                })
        })
    },
    FETCH_SUPERVISORS: ({state, commit, rootState}) => {
        return api.get({path: 'supervisors'})
            .then((res) => {
                // console.log(res)
                commit(SET_SUPERVISORS, res)
            })
    },
    FETCH_APPRAISALREPORTS: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.get({path: 'appraisalreports'})
                .then((res) => {
                    // console.log(res)
                    commit(SET_APPRAISALREPORTS, res)
                    resolve(res)
                })
        })
    },
    FETCH_CONTACTS: ({state, commit, rootState}) => {
        return api.getContacts()
            .then((res) => {
                // console.log(res)
                commit(SET_CONTACTS, res)
            })
    },
    FETCH_APPRAISALINVOICES: ({state, commit, rootState}) => {
        return api.get({path: 'appraisalinvoices'})
            .then((res) => {
                // console.log(res)
                commit(SET_APPRAISALINVOICES, res)
            })
    },
    FETCH_APPRAISALQUOTES: ({state, commit, rootState}) => {
        return api.get({path: 'appraisalquotes'})
            .then((res) => {
                // console.log(res)
                commit(SET_APPRAISALQUOTES, res)
            })
    },
    FETCH_STATS_CURRENT: ({state, commit, rootState}) => {
        return api.get({path: 'stats/current'})
            .then((res) => {
                // console.log(res)
                commit(SET_STATS_CURRENT, res)
            })
    },
    FETCH_ENTITIES: ({state, commit, rootState}) => {
        return api.get({path: 'entities'})
            .then((res) => {
                // console.log(res)
                commit(SET_ENTITIES, res)
            })
    },
    FETCH_USER_DATA: ({state, commit, rootState}) => {
        return api.getDataForUserId(rootState.auth.user.uid)
            .then((res) => {
                //commit(SET_NOTES, res.notes)
                // commit(SET_THEME, res.theme)
                commit(SET_USER_ROLE, res.role)

                //nota: origialment no era així, això sobreescriu l'objecte user per defecte, que conté altres dades de quan fas logion, potser eren importants?
                commit(SET_USER, res)
            })
    },
    FETCH_USER_APPRAISALS: ({state, commit, rootState}) => {
        return api.getAppraisalIdsForUserId(rootState.auth.user.uid)
            .then((res) => {
                return api.getAppraisals(res.appraisal_ids)
                    .then((res) => {
                        commit(SET_APPRAISALS, res.appraisals)
                    })
            })
    },

    FETCH_VALUATION_PRICES: ({state, commit, rootState}) => {
        return new Promise((resolve, reject) => {
            return api.getValuationPrices()
                .then((res) => {
                    commit(SET_VALUATION_PRICES, res)
                    resolve(res)
                })
        })
    },
    FETCH: ({state, commit, rootState}, data) => {
        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then((res) => {
                    resolve(res)
                })
        })
    },
    FETCH_PREVIEW_DATA: ({state, commit, rootState}) => {
        return api.getPreviewData()
            .then((res) => {
                commit(SET_NOTES, res.notes)
                commit(SET_THEME, res.theme)
            })
    },

    CREATE_NOTE: ({state, commit, rootState}, note) => {
        if (rootState.auth.user) {
            return api.createNote(rootState.auth.user.uid, note)
                .then((key) => {
                    commit(SET_RESULT_INDEX, 0)
                    commit(CREATE_NOTE, {key: key, note: note})
                })
        } else {
            commit(SET_RESULT_INDEX, 0)
            commit(CREATE_NOTE, {key: note.id, note: note})
        }
    },

    UPDATE_BUDGET_REQUEST: ({state, commit, rootState}, data) => {
        return api.updateBudgetRequest(data)
            .then((res) => commit(UPDATE_BUDGET_REQUEST, {data: data}))
    },
    /*
        UPDATE_NOTE: ({state, commit, rootState}) => {
            if (rootState.auth.user) {
                return api.updateNote(rootState.auth.user.uid, state.activeKey, state.activeNote)
                    .then((res) => commit(UPDATE_NOTE, {key: res.key, date_modified: res.date_modified}))
            } else {
                const dateModified = moment().toString()
                commit(UPDATE_NOTE, {key: state.activeKey, date_modified: dateModified})
            }
        },

        DELETE_NOTE: ({state, commit, rootState}) => {
            if (rootState.auth.user) {
                return api.deleteNote(rootState.auth.user.uid, state.activeKey)
                    .then(() => { commit(DELETE_NOTE, state.activeKey)})
            } else {
                commit(DELETE_NOTE, state.activeKey)
            }
        },
        */

    SET_APPRAISAL_FLOOR_NUMBER_BY_KEY: ({state, commit, rootState}, data) => {
        return api.set_value({
            path: 'realestate_appraisals/' + data.realestate_id + '/' + data.appraisal_id + '/' + 'floor_number',
            value: data.floor_number
        })
    },

    SET_APPRAISAL_PROPERTY_TYPE_BY_KEY: ({state, commit, rootState}, data) => {
        return api.set_value({
            path: 'realestate_appraisals/' + data.realestate_id + '/' + data.appraisal_id + '/' + 'property_type',
            value: data.property_type
        })
    },


    UPDATE_THEME: ({state, commit, rootState}, theme) => {
        if (rootState.auth.user) {
            return api.updateTheme(rootState.auth.user.uid, theme)
                .then((theme) => commit(SET_THEME, theme))
        } else {
            commit(SET_THEME, theme)
        }
    },

    UPDATE_LANGUAGE: ({state, commit, rootState}, language) => {
        commit(SET_LANGUAGE, language)
        /*
        if (rootState.auth.user) {
            return api.updateTheme(rootState.auth.user.uid, language)
                .then((language) => commit(SET_LANGUAGE, language))

        } else {
            commit(SET_LANGUAGE, language)
        }
        */
    },

    TOGGLE_IS_PUBLIC: ({state, commit, rootState}, note) => {
        return api.toggleIsPublic(rootState.auth.user.uid, state.activeKey, note)
            .then((res) => commit(TOGGLE_IS_PUBLIC, {key: res.key, is_public: res.is_public}))
    },

    FETCH_PUBLIC_NOTE_FOR_ID: ({state, commit, rootState}, noteId) => {
        return api.getPublicNoteForId(noteId)
            .then((note) => commit(SET_ACTIVE_NOTE, note))
    },
    GET: ({state, commit, rootState}, data) => {

        return new Promise((resolve, reject) => {
            return api.get({path: data.path})
                .then(res => resolve(res))
        })

    },
}

const mutations = {

    [CREATE_NOTE] (state, data) {
        Vue.set(state.notes, data.key, data.note)
        state.activeKey = data.key
        state.activeNote = data.note
    },

    [DELETE_NOTE] (state, key) {
        Vue.delete(state.notes, key)
    },

    [SET_ACTIVE_CONTACT] (state, contact) {
        state.activeContact = contact
    },

    [SET_ACTIVE_NOTE] (state, note) {
        state.activeNote = note
    },

    [SET_ACTIVE_KEY] (state, key) {
        state.activeKey = key
    },
    [SET_APPRAISALS] (state, data) {
        state.appraisals = data
    },
    [SET_WARNINGS] (state, data) {
        state.warnings = data
    },
    [SET_CONSTRAINTS] (state, data) {
        state.constraints = data
    },
    [SET_MARKETSTUDIES] (state, data) {
        state.marketstudies = data
    },
    [SET_AD_COMPARABLES] (state, data) {
        state.ad_comparables = data
    },
    [SET_APPRAISERS] (state, data) {
        state.appraisers = data
    },
    [SET_REALESTATES] (state, data) {
        state.realestates = data
    },
    [SET_SUPERVISORS] (state, data) {
        state.supervisors = data
    },
    [SET_APPRAISALREPORTS] (state, data) {
        state.appraisalreports = data
    },
    [SET_APPRAISALINVOICES] (state, data) {
        state.appraisalinvoices = data
    },

    [SET_APPRAISALQUOTES] (state, data) {
        state.appraisalquotes = data
    },
    [SET_STATS_CURRENT] (state, data) {
        state.stats_current = data
    },
    [SET_CONTACTS] (state, contacts) {
        state.contacts = contacts
    },
    [SET_BECPROPERTIES] (state, data) {
        state.becproperties = data
    },
    [SET_ENTITIES] (state, data) {
        state.entities = data
    },
    [SET_LANGUAGE] (state, language) {
        state.language = language
        Vue.i18n.set(language)
    },

    [SET_NOTES] (state, notes) {
        state.notes = notes
    },

    [SET_TAGS_DISPLAY] (state, data) {
        state.tags_display = data
    },

    [SET_THEME] (state, theme) {
        state.theme = theme
    },

    [SET_USER_ROLE] (state, user_role) {
        state.user_role = user_role
    },

    [SET_VALUATION_PRICES] (state, valuation_prices) {
        state.valuation_prices = valuation_prices
    },
    [TOGGLE_IS_PUBLIC] (state, data) {
        let note = state.notes[`${data.key}`]
        note.is_public = data.is_public
    },
    [UPDATE_BUDGET_REQUEST] (state, data) {
        state.budget_request_data = data
    },
    [UPDATE_NOTE] (state, data) {
        let note = state.notes[`${data.key}`]
        note.date_modified = data.date_modified
    },
    [SET_BDE_APPRAISAL_FILES] (state, value) {
        state.bde_appraisal_files = value
    },
    [SET_BDE_REALESTATE_FILES] (state, value) {
        state.bde_realestate_files = value
    },
    [SET_BDE_COMPARABLE_FILES] (state, value) {
        state.bde_comparable_files = value
    },
    [SET_BDE_RELATIONSHIPS_FILES] (state, value) {
        state.bde_relationships_files = value
    }
}

const getters = {
    activeContact: state => {
        return state.activeContact
    },
    activeKey: state => {
        return state.activeKey
    },
    activeNote: state => {
        return state.activeNote
    },
    bde_appraisal_files: state => {
        return state.bde_appraisal_files
    },
    bde_realestate_files: state => {
        return state.bde_realestate_files
    },
    bde_comparable_files: state => {
        return state.bde_comparable_files
    },
    bde_relationships_files: state => {
        return state.bde_relationships_files
    },
    budget_request_data: state => {
        return state.budget_request_data
    },
    appraisers: state => {
        return state.appraisers
    },
    constraints: state => {
        return state.constraints
    },
    realestates: state => {
        return state.realestates
    },
    stats_current: state => {
        return state.stats_current
    },
    supervisors: state => {
        return state.supervisors
    },
    appraisals: state => {
        return state.appraisals
    },
    marketstudies: state => {
        return state.marketstudies
    },
    ad_comparables: state => {
        return state.ad_comparables
    },
    appraisalreports: state => {
        return state.appraisalreports
    },
    appraisalinvoices: state => {
        return state.appraisalinvoices
    },
    appraisalquotes: state => {
        return state.appraisalquotes
    },
    contacts: state => {
        return state.contacts
    },
    becproperties: state => {
        return state.becproperties
    },
    entities: state => {
        return state.entities
    },
    language: state => {
        return state.language
    },
    notes: state => {
        return state.notes
    },
    tags_display: state => {
        return state.tags_display
    },
    theme: state => {
        return state.theme
    },
    user_role: state => {
        return state.user_role
    },
    valuation_prices: state => {
        return state.valuation_prices
    },
    warnings: state => {
        return state.warnings
    }
}

export default {
    state,
    actions,
    mutations,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/nv.js